import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { ModuleMethodSetupHistoryProps } from "./companyMethodContracts";

export function ModuleMethodSetupHistory({ page, resumingOperationId, resumeDisabled, onResume, onPage }: ModuleMethodSetupHistoryProps) {
  if (page.total === 0 && page.offset === 0) return null;
  return <Stack spacing={1.5} aria-label="Original company card setups">
    {page.items.map(item => <Stack key={item.operation_id} direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ alignItems: { sm: "center" } }}>
      <Typography variant="body2" sx={{ flex: 1 }}>
        {new Date(item.created_at).toLocaleString()} — {item.operation_status === "failed" ? "Card setup failed"
          : item.operation_status === "uncertain" ? "Setup outcome unknown"
          : item.operation_status === "completed" ? (item.application === "current" ? "Card setup complete" : "Setup recorded; not current")
          : "Card setup pending"}
      </Typography>
      <Button size="small" disabled={resumeDisabled || resumingOperationId !== null} onClick={() => onResume(item.operation_id)}>
        {resumingOperationId === item.operation_id ? "Checking…" : item.operation_status === "pending" ? "Resume card setup" : "Check setup status"}
      </Button>
    </Stack>)}
    {page.offset > 0 || page.total > page.limit ? <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <Typography variant="body2">{page.total} original setups</Typography>
      <Button size="small" disabled={page.offset === 0 || resumingOperationId !== null}
        onClick={() => onPage(Math.max(0, page.offset - page.limit))}>Previous</Button>
      <Button size="small" disabled={page.offset + page.limit >= page.total || resumingOperationId !== null}
        onClick={() => onPage(page.offset + page.limit)}>Next</Button>
    </Stack> : null}
  </Stack>;
}
